// extracted by mini-css-extract-plugin
module.exports = {"table":"PricingCards_table__M7cvB","cards":"PricingCards_cards__F7VW1","origin-pricing":"PricingCards_origin-pricing__Bgusl"};